/** @jsxRuntime automatic */
/** @jsxImportSource react */
import { CircleAlert, CircleCheck } from 'lucide-react';
import { Icon } from '../ui/Icon';

/**
 * A save's outcome under its form: the service's own sentence when it refused, so nothing fails silently. A `<p>`
 * with role status or alert, as the render tests find it; its colours are the kit's status tokens (ui-note, kit.css).
 */
export function SaveNote({ note }: { note: { ok: boolean; text: string } | null }) {
  if (!note) return null;
  return (
    <p className={`ui-note ${note.ok ? 'is-ok' : 'is-bad'}`} role={note.ok ? 'status' : 'alert'}>
      <Icon icon={note.ok ? CircleCheck : CircleAlert} size="sm" />
      <span>{note.text}</span>
    </p>
  );
}
